import { cliSimpleGit } from '../cli-simple-git.js';
import { runGitTask } from '../git-runtime.js';
import { workingTreeChangedPathCount } from './status/working-tree-changed-path-count.js';

/** Distinct uncommitted paths in one repo (tracked diff vs `HEAD` + untracked). */
export async function countWorkingTreeChangedFilesForRepo(repoGitCwd: string): Promise<number> {
  return runGitTask(async () => {
    const g = cliSimpleGit(repoGitCwd);
    const [nameStatusRaw, numstatRaw, untrackedRaw] = await Promise.all([
      g.raw(['diff', '--name-status', 'HEAD']).catch(() => ''),
      g.raw(['diff', 'HEAD', '--numstat']).catch(() => ''),
      g.raw(['ls-files', '--others', '--exclude-standard']).catch(() => ''),
    ]);
    return workingTreeChangedPathCount(
      String(nameStatusRaw).split('\n'),
      String(numstatRaw).split('\n'),
      String(untrackedRaw).split('\n'),
    );
  });
}
